module.exports = __webpack_public_path__ + "frontend/images/gold/bg/pattern@2.png?cc5d077e428f296dc7a09c75ac1a0ef0";